import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { ArrowRight } from 'react-feather'
import Link from 'next/link'

const DynamicCODBlocking = () => {
  const { t } = useLocale()

  return (
    <div className='flex justify-between items-center pt-4'>
      <div className='flex flex-row justify-between'>
        <div className='flex flex-col gap-2 text-sm'>
          <h2 className='font-medium text-carbon'>{t('dynamic_cod_blocking_header')}</h2>
          <p className='font-normal leading-5 text-gray-dark'>{t('dynamic_cod_blocking_description')}</p>
        </div>
      </div>
      <Link
        href='/automations'
        className='flex items-center gap-1 text-sm max-h-9 text-nowrap font-semibold cursor-pointer p-2 rounded-lg border-1  hover:ring-2 hover:ring-coal-lighter transition-all duration-200'
      >
        {t('go_to_automations')}
        <ArrowRight className='w-4 h-4' />
      </Link>
    </div>
  )
}

export default DynamicCODBlocking
